<template>
  <header>
    <div class="header-area h-style5">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-3">
            <div class="logo">
              <a href="index.html">
                <img src="static/picture/logo-white.png" alt="logo">
              </a>
            </div>
          </div>
          <div class="col-9 d-sm-block d-lg-none">
            <a href="javascript:;" class="lang" @click="langSwitch">{{ $tm('navButtonName') }}</a>
          </div>
          <div class="col-lg-9 d-none d-lg-block">
            <div class="main-menu">
              <nav id="nav_mobile_menu">
                <ul id="navigation">
                  <li v-for="(nav,index) in $tm('navs')" :key="index" :class="active == index ? 'active' : ''" @click="clickNav(index)">
                    <a v-if="nav.isBlank" :href="nav.url  + '?lang=' + tm('lang') " target="_blank">{{ nav.name}}</a>
                    <a v-else :href="nav.url">{{ nav.name }}</a>
                  </li>
                  <li>
                    <a href="javascript:;" @click="langSwitch">{{ $tm('navButtonName') }}</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div class="col-12 d-block d-lg-none">
            <div id="mobile_menu"></div>
          </div>
        </div>
      </div>
    </div>
  </header>
  </template>
  
  <script>
  import { useI18n } from 'vue-i18n';

  export default {
    name: "Header",
    data(){
      return{
        tm: null, 
        lang: null, 
        langName: null, 
        active: null,
        locale: null,
      }
    },
    created(){
      const { tm, locale } = useI18n();
      let lang = this.$store.get('lang');
      console.log(lang)
      if(lang){
        this.lang = lang;
        locale.value = lang;
      }else{
        let lang = locale.value;
        this.lang = lang;
        this.setLang(lang);
      }
      if(this.lang == 'en'){
        this.langName = '中文';
      }else{
        this.langName = 'English';
      }
      this.tm = tm;
      this.active = 0;
      this.locale = locale
    },
    methods: {
      clickNav(index){
        this.active = index;
      },
      langSwitch(){
        if(this.lang == 'zh'){
          this.lang = 'en';
          this.langName = '中文'
        }else{
          this.lang = 'zh';
          this.langName = 'English'
        }
        this.$i18n.locale = this.lang
        this.setLang(this.lang)
      },
      setLang(lang){
        this.$store.set('lang', lang)
      }
    }
  };
  </script>
  
  <style scoped>
  /* 针对头部样式 */
  </style>
  